import { Reducer } from "redux";

import { FrequentlyAskedQuestionResponse } from "../models/api/Faqs";
import { FrequentlyAskedQuestionDispatchTypes } from "../models/dispatchTypes/Faqs";
import { GetFrequentlyAskedQuestionActionDispatchTypes } from "../constants/Faqs";

export const initialState: FrequentlyAskedQuestionResponse = {
  loading: false,
  response: {
    mainLine: "",
    contactInformation: [],
    questionData: [],
  },
};

const FaqsReducer: Reducer<
  FrequentlyAskedQuestionResponse,
  FrequentlyAskedQuestionDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetFrequentlyAskedQuestionActionDispatchTypes.GET_FREQUENTLY_ASKED_QUESTION_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetFrequentlyAskedQuestionActionDispatchTypes.GET_FREQUENTLY_ASKED_QUESTION_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
  }
  return state;
};

export default FaqsReducer;
